import React, { useState, useEffect } from "react";
import { CustomerViewDetailsViewAttachmentInfoProps } from "./customer-view-details-view-attachment-info.props";
import "./customer-view-details-view-attachment-info.scss";
import ListAttachMents from "./list-attachments";
import { AlertComponent } from "../../../../../../common/components";
import {
  getCustomerDetails,
} from "../../../../../../api/customer";
import UploadDropDown from "./upload-dropdown";
import UploadFileAttachment from "./upload-file-attachment";
import UploadLinkUrlAttachment from "./upload-link-url-attachment";

const CustomerViewDetailsViewAttachmentInfo: React.FC<
  CustomerViewDetailsViewAttachmentInfoProps
> = ({ setLoading, customerId, disableEdit, permissions }) => {
  const [selectedOption, setSelectedOption] = useState("");
  const [attachmentsList, setAttachmentsList] = useState([]);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");

  const handleOptionChange = (e: any) => {
    setSelectedOption(e.target.value);
  };

  const fetchAttachments = async () => {
    setLoading(true);
    try {
      const response = await getCustomerDetails(customerId);
      setAttachmentsList(response?.data?.data?.attachments);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message || "Failed to get customer attachments.",
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchAttachments();
  }, [customerId]);

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  return (
    <div className="customer-list-view-details-view-box-attachment-info">
      <div className="customer-list-view-details-view-box-attachment-info-header">
        <div className="customer-list-view-details-view-box-attachment-info-header-text">
          Attachments
        </div>
        <div>
          <UploadDropDown
            selectedOption={selectedOption}
            handleChange={handleOptionChange}
            disableEdit={disableEdit || !permissions?.canWrite}
          />
          <UploadFileAttachment
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            customerId={customerId}
            setLoading={setLoading}
            fetchAttachments={fetchAttachments}
          />
          <UploadLinkUrlAttachment
            selectedOption={selectedOption}
            setSelectedOption={setSelectedOption}
            customerId={customerId}
            setLoading={setLoading}
            fetchAttachments={fetchAttachments}
          />
        </div>
      </div>
      {attachmentsList?.length > 0 ? (
        <div className="customer-list-view-details-view-box-attachment-info-list">
          <ListAttachMents
            customerId={customerId}
            attachmentsList={attachmentsList}
            fetchAttachments={fetchAttachments}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            disableEdit={disableEdit || !permissions?.canWrite}
          />
        </div>
      ) : (
        <div className="customer-list-view-details-view-box-attachment-info-no-data">
          No Attachments
        </div>
      )}
      <AlertComponent
        message={alertMessage}
        type={alertType}
        open={alertOpen}
        onClose={handleAlertClose}
      />
    </div>
  );
};

export default CustomerViewDetailsViewAttachmentInfo;
